module.exports = __webpack_public_path__ + "static/media/Pasta de coditos con mayonesa.6fd03739.png";